import { render } from "./AdminBookingsView.vue?vue&type=template&id=949b0e12&ts=true&lang=pug"
import script from "./AdminBookingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminBookingsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__